import React from 'react'
import { Redirect } from 'react-router-dom'
import { usePageData } from '../../_metronic/layout/core'
import { PAGE_ACTION, PAGE_PERMISSION } from '../modules/roles/constant/role-default'
import {useProjectSelection} from '../modules/projectdetails/hooks/useProjectSelection'
import {isSelectionRouteDisabled} from '../modules/projectdetails/selectionMode'

const ActivePageBasedRedirect = () => {
  const {isPortfolio} = useProjectSelection()
  const {
    currentUser: { activePages },
  } = usePageData()

  if (!activePages) {
    return null
  }

  if (isPortfolio) {
    return <Redirect to='/portfolio-overview' />
  }

  const permissionsOrder = [
    { permission: PAGE_PERMISSION.Dashboard, route: '/dashboard' },
    { permission: `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.View}`, route: '/dashboard' },
    { permission: `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Create}`, route: '/dashboard' },
    { permission: `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Update}`, route: '/dashboard' },
    { permission: `${PAGE_PERMISSION.Dashboard}.${PAGE_ACTION.Delete}`, route: '/dashboard' },
    { permission: PAGE_PERMISSION.Project_SetupWizard, route: '/project-setup' },
    { permission: `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.View}`, route: '/project-setup' },
    { permission: `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Create}`, route: '/project-setup' },
    { permission: `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Update}`, route: '/project-setup' },
    { permission: `${PAGE_PERMISSION.Project_SetupWizard}.${PAGE_ACTION.Delete}`, route: '/project-setup' },
    { permission: PAGE_PERMISSION.Project_Details, route: '/project-details' },
    { permission: `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.View}`, route: '/project-details' },
    { permission: `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Create}`, route: '/project-details' },
    { permission: `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Update}`, route: '/project-details' },
    { permission: `${PAGE_PERMISSION.Project_Details}.${PAGE_ACTION.Delete}`, route: '/project-details' },
    { permission: PAGE_PERMISSION.Cashflow, route: '/cashflow' },
    { permission: `${PAGE_PERMISSION.Cashflow}.${PAGE_ACTION.View}`, route: '/cashflow' },
    { permission: `${PAGE_PERMISSION.Cashflow}.${PAGE_ACTION.Create}`, route: '/cashflow' },
    { permission: `${PAGE_PERMISSION.Cashflow}.${PAGE_ACTION.Update}`, route: '/cashflow' },
    { permission: `${PAGE_PERMISSION.Cashflow}.${PAGE_ACTION.Delete}`, route: '/cashflow' },
    { permission: PAGE_PERMISSION.Budget, route: '/budget' },
    { permission: `${PAGE_PERMISSION.Budget}.${PAGE_ACTION.View}`, route: '/budget' },
    { permission: `${PAGE_PERMISSION.Budget}.${PAGE_ACTION.Create}`, route: '/budget' },
    { permission: `${PAGE_PERMISSION.Budget}.${PAGE_ACTION.Update}`, route: '/budget' },
    { permission: `${PAGE_PERMISSION.Budget}.${PAGE_ACTION.Delete}`, route: '/budget' },
    { permission: PAGE_PERMISSION.Milestones, route: '/milestones' },
    { permission: `${PAGE_PERMISSION.Milestones}.${PAGE_ACTION.View}`, route: '/milestones' },
    { permission: `${PAGE_PERMISSION.Milestones}.${PAGE_ACTION.Create}`, route: '/milestones' },
    { permission: `${PAGE_PERMISSION.Milestones}.${PAGE_ACTION.Update}`, route: '/milestones' },
    { permission: `${PAGE_PERMISSION.Milestones}.${PAGE_ACTION.Delete}`, route: '/milestones' },
    { permission: PAGE_PERMISSION.Document_Registry, route: '/document-registry' },
    { permission: `${PAGE_PERMISSION.Document_Registry}.${PAGE_ACTION.View}`, route: '/document-registry' },
    { permission: `${PAGE_PERMISSION.Document_Registry}.${PAGE_ACTION.Create}`, route: '/document-registry' },
    { permission: `${PAGE_PERMISSION.Document_Registry}.${PAGE_ACTION.Update}`, route: '/document-registry' },
    { permission: `${PAGE_PERMISSION.Document_Registry}.${PAGE_ACTION.Delete}`, route: '/document-registry' },
    { permission: PAGE_PERMISSION.Contacts, route: '/contacts' },
    { permission: `${PAGE_PERMISSION.Contacts}.${PAGE_ACTION.View}`, route: '/contacts' },
    { permission: `${PAGE_PERMISSION.Contacts}.${PAGE_ACTION.Create}`, route: '/contacts' },
    { permission: `${PAGE_PERMISSION.Contacts}.${PAGE_ACTION.Update}`, route: '/contacts' },
    { permission: `${PAGE_PERMISSION.Contacts}.${PAGE_ACTION.Delete}`, route: '/contacts' },
    { permission: PAGE_PERMISSION.Reports_VariationAssessments, route: '/variation-assessments' },
    { permission: `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.View}`, route: '/variation-assessments' },
    { permission: `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Create}`, route: '/variation-assessments' },
    { permission: `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Update}`, route: '/variation-assessments' },
    { permission: `${PAGE_PERMISSION.Reports_VariationAssessments}.${PAGE_ACTION.Delete}`, route: '/variation-assessments' },
    { permission: PAGE_PERMISSION.Reports_ProgressClaim, route: '/progress-claim' },
    { permission: `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.View}`, route: '/progress-claim' },
    { permission: `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Create}`, route: '/progress-claim' },
    { permission: `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Update}`, route: '/progress-claim' },
    { permission: `${PAGE_PERMISSION.Reports_ProgressClaim}.${PAGE_ACTION.Delete}`, route: '/progress-claim' },
    { permission: PAGE_PERMISSION.Reports_PcgReport, route: '/pcg-report' },
    { permission: `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.View}`, route: '/pcg-report' },
    { permission: `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Create}`, route: '/pcg-report' },
    { permission: `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Update}`, route: '/pcg-report' },
    { permission: `${PAGE_PERMISSION.Reports_PcgReport}.${PAGE_ACTION.Delete}`, route: '/pcg-report' },
    { permission: PAGE_PERMISSION.Charts, route: '/charts' },
    { permission: `${PAGE_PERMISSION.Charts}.${PAGE_ACTION.View}`, route: '/charts' },
    { permission: `${PAGE_PERMISSION.Charts}.${PAGE_ACTION.Create}`, route: '/charts' },
    { permission: `${PAGE_PERMISSION.Charts}.${PAGE_ACTION.Update}`, route: '/charts' },
    { permission: `${PAGE_PERMISSION.Charts}.${PAGE_ACTION.Delete}`, route: '/charts' },
    { permission: PAGE_PERMISSION.Settings, route: '/settings' },
    { permission: `${PAGE_PERMISSION.Settings}.${PAGE_ACTION.View}`, route: '/settings' },
    { permission: `${PAGE_PERMISSION.Settings}.${PAGE_ACTION.Create}`, route: '/settings' },
    { permission: `${PAGE_PERMISSION.Settings}.${PAGE_ACTION.Update}`, route: '/settings' },
    { permission: `${PAGE_PERMISSION.Settings}.${PAGE_ACTION.Delete}`, route: '/settings' },
    { permission: PAGE_PERMISSION.Admin_Audit, route: '/audit' },
    { permission: `${PAGE_PERMISSION.Admin_Audit}.${PAGE_ACTION.View}`, route: '/audit' },
    { permission: `${PAGE_PERMISSION.Admin_Audit}.${PAGE_ACTION.Create}`, route: '/audit' },
    { permission: `${PAGE_PERMISSION.Admin_Audit}.${PAGE_ACTION.Update}`, route: '/audit' },
    { permission: `${PAGE_PERMISSION.Admin_Audit}.${PAGE_ACTION.Delete}`, route: '/audit' },
    { permission: PAGE_PERMISSION.Admin_Audit_Logs, route: '/audit-logs' },
    { permission: `${PAGE_PERMISSION.Admin_Audit_Logs}.${PAGE_ACTION.View}`, route: '/audit-logs' },
    { permission: `${PAGE_PERMISSION.Admin_Audit_Logs}.${PAGE_ACTION.Create}`, route: '/audit-logs' },
    { permission: `${PAGE_PERMISSION.Admin_Audit_Logs}.${PAGE_ACTION.Update}`, route: '/audit-logs' },
    { permission: `${PAGE_PERMISSION.Admin_Audit_Logs}.${PAGE_ACTION.Delete}`, route: '/audit-logs' },
    { permission: PAGE_PERMISSION.Users, route: '/user' },
    { permission: `${PAGE_PERMISSION.Users}.${PAGE_ACTION.View}`, route: '/user' },
    { permission: `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Create}`, route: '/user' },
    { permission: `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Update}`, route: '/user' },
    { permission: `${PAGE_PERMISSION.Users}.${PAGE_ACTION.Delete}`, route: '/user' },
    { permission: PAGE_PERMISSION.Roles, route: '/role' },
    { permission: `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.View}`, route: '/role' },
    { permission: `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Create}`, route: '/role' },
    { permission: `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Update}`, route: '/role' },
    { permission: `${PAGE_PERMISSION.Roles}.${PAGE_ACTION.Delete}`, route: '/role' },
    { permission: `${PAGE_PERMISSION.Notification}.${PAGE_ACTION.View}`, route: '/notifications' },
  ];

  for (let { permission, route } of permissionsOrder) {
    if (!isSelectionRouteDisabled(route, isPortfolio) && activePages.some((page) => page.name === permission)) {
      return <Redirect to={route} />
    }
  }

  return null
}

export default ActivePageBasedRedirect
